import { Controller } from "@hotwired/stimulus";

// Lets chips and example phrases populate a text field. Column chips `insert` their text at
// the cursor so an instruction can be built up word by word; example phrases `replace` the
// whole field as a ready-made starting point. Used on the import reformat panel.
export default class extends Controller {
  static targets = ["field"];

  insert(event) {
    event.preventDefault();
    this.#insertAtCursor(this.#textFrom(event));
  }

  replace(event) {
    event.preventDefault();
    this.fieldTarget.value = this.#textFrom(event);
    this.fieldTarget.focus();
  }

  #textFrom(event) {
    return event.params.text.trim();
  }

  #insertAtCursor(text) {
    const field = this.fieldTarget;
    const start = field.selectionStart ?? field.value.length;
    const end = field.selectionEnd ?? field.value.length;
    const before = field.value.slice(0, start);
    const after = field.value.slice(end);
    const spacer = before && !/\s$/.test(before) ? " " : "";

    field.value = `${before}${spacer}${text}${after}`;
    const caret = before.length + spacer.length + text.length;
    field.setSelectionRange(caret, caret);
    field.focus();
  }
}
